import { fetchBaseQuery as o, createApi as n } from "@reduxjs/toolkit/query/react";
const s = {
  get: "success-stories/initial-load-data",
  apply: "success-stories/testimonials"
}, a = o({
  baseUrl: "/",
  prepareHeaders: async (e) => {
    const t = document.querySelector('meta[name="csrf-token"]');
    return t && e.set("X-CSRF-Token", t.content), e.set("Accept", "application/json"), e.set("Content-Type", "application/json"), e.set("X-Requested-With", "XMLHttpRequest"), e;
  }
}), i = n({
  reducerPath: "filter-recommendations",
  async baseQuery(...e) {
    return await a(...e);
  },
  endpoints: (e) => ({
    getFilters: e.query({
      query: () => ({
        method: "GET",
        url: s.get
      })
    }),
    applyFilters: e.mutation({
      query: ({ q: t }) => ({
        method: "POST",
        url: s.apply,
        body: {
          q: t,
          page_number: 1,
          per_page: 10,
          sort_by: "eligible_for_qna"
        }
      }),
      transformResponse: ({ data: t, total_entries: r }) => ({ data: t, total_entries: r })
    })
  })
}), {
  useGetFiltersQuery: c,
  useApplyFiltersMutation: u
} = i;
export {
  i as default,
  u as useApplyFiltersMutation,
  c as useGetFiltersQuery
};
